import { SxProps } from "@mui/material";

export const sxInputLarge: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  width: 'stretch',
  maxWidth: '620px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    width: 'stretch'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxInputSmall: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  width: '300px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    width: 'stretch'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxObservationTextField: SxProps = {
  width: '100%',
  maxWidth: '620px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    width: 'stretch'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  },
  "& .MuiOutlinedInput-root": {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '150px',
    fontFamily: 'Unimed-Sans',
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontSize: '14px',
  }
}

export const sxTableMaxWidth: SxProps = {
  borderRadius: '10px',
  width: '100%',
  maxWidth: '1000px',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}